import React from 'react';

import { REFERRAL_STATUS, REFERRAL_STATUS_OUTBOUND } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FiltersReferralStatusPorps {
  referralType: string;
}

const FiltersReferralStatus: React.FC<FiltersReferralStatusPorps> = ({ referralType }) => (
  <FiltersSelectContent
    type="referralStatus"
    items={referralType === 'inbound' ? REFERRAL_STATUS : REFERRAL_STATUS_OUTBOUND}
  />
);
export default FiltersReferralStatus;
